<script>
  export let classes
</script>

<div class="inline-flex items-center mr-1 text-sm font-bold text-gray-700 ">
  <span class="w-20 px-2 mb-1 py-1 text-center uppercase w-min- {classes}">
    <slot />
  </span>
</div>
